export default __webpack_public_path__ + "static/media/reject.f27d7a98.svg";